const RainShader = {
  uniforms: {
    texture1: { value: null },
    texture2rain: { value: null },
    iTime: { value: 0 },
    size: { value: 5.0 },
    snowT1density: { value: 0.5 },
    rainT1density: { value: 0.5 },
    snowSpeed: { value: 1.0 },
    cameraPos: { value: null },
    rainSpeed: { value: 3.0 }, // 下雨速度
    rainAngle: { value: -0.0 }, // 下雨倾斜角度-0.1
  },
  vertexShaderNear: `
  varying highp vec2 vUv;
  uniform vec3 cameraPos;
  varying float vDistance;
  #include <common>
  #include <logdepthbuf_pars_vertex>
      void main() {
        #include <begin_vertex>
        #include <project_vertex>
        #include <logdepthbuf_vertex>
       vUv = uv;
       vec4 worldPosition4 = modelMatrix * vec4(position, 1.0);
       vec3 worldPosition = worldPosition4.xyz;
       vDistance = distance(worldPosition, cameraPos);

  }`,
  fragmentShaderNear: ` 
  #include <logdepthbuf_pars_fragment>
  #define PI 3.14159265359

  uniform sampler2D texture1;
  uniform sampler2D texture2rain;

  uniform float iTime;
  uniform float size;
  uniform float snowT1density;
  uniform float rainT1density;
  uniform float snowSpeed;

  varying highp vec2 vUv;
  varying float vDistance;
  
  void main(){

    #include <logdepthbuf_fragment>
      vec2 uv= vUv*size;

     vec2 sownMove= vUv*size;
     sownMove.y+=iTime*0.04*snowSpeed;

     vec2 rainMove= uv*10.;
     rainMove.y+=iTime*0.2*snowSpeed;
   
      vec3 T1 = texture(texture1, sownMove).rgb*snowT1density;
      vec3 T2 = texture(texture2rain, rainMove).rgb*rainT1density;

      if (vDistance < 100.) {
        gl_FragColor = vec4(1);
      }else{gl_FragColor = vec4((T2),1.);}

      //gl_FragColor = vec4((T1+T2),1.);
      
      //gl_FragColor = vec4(1.,0.,0.,0.5);
  }`,

  vertexShaderFar: `
  varying highp vec2 vUv;
  varying vec3 vPosition;
  uniform vec3 cameraPos;
  #include <common>
  #include <logdepthbuf_pars_vertex>
      void main() {
        #include <begin_vertex>
        #include <project_vertex>
        #include <logdepthbuf_vertex>
       vUv = uv;
         
   //  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

    vec4 modelPosition = modelMatrix * vec4(position, 1.0);
    modelPosition.xyz += (cameraPos*1. );
    gl_Position = projectionMatrix * viewMatrix * modelPosition;

  }`,
  fragmentShaderFar: ` 
  #include <logdepthbuf_pars_fragment>
  #define PI 3.14159265359

  uniform sampler2D texture1;
  uniform sampler2D texture2rain;

  uniform float iTime;
  uniform float size;
  uniform float snowT1density;
  uniform float rainT1density;
  uniform float snowSpeed;

  varying highp vec2 vUv;

  void main(){

    #include <logdepthbuf_fragment>
      vec2 uv= vUv*size;
/*    
      float angle = radians(10.0);
mat2 rotationMatrix = mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
uv = rotationMatrix * (uv - vec2(0.5, 0.5)) + vec2(0.5, 0.5);
*//////水平旋转
/*
float distortAmount = 0.1;  // 控制扭曲的程度
uv.x = uv.x + distortAmount * sin(uv.y * 20.0);
*//////扭曲

// float perspectiveStrength = -0.2;  // 控制透视强度
// uv.y = mix(1.0 -uv.y,  uv.y, pow(uv.y, perspectiveStrength));


     vec2 sownMove= vUv*size;
     sownMove.y+=iTime*0.04*snowSpeed;
     //sownMove.x+=sin(iTime*0.3)*0.001*snowSpeed;

     vec2 rainMove= uv;
     rainMove.y+=iTime*0.2*snowSpeed;
   
      vec3 T1 = texture(texture1, sownMove).rgb*snowT1density;
      vec3 T2 = texture(texture2rain, rainMove).rgb*rainT1density;

      gl_FragColor = vec4((T1+T2),1.);
      //gl_FragColor = vec4(1.,0.,0.,0.5);
  }`,

  vertexShader2d: `
      varying highp vec2 vUv;
      varying float vPitch;
      #include <common>
  #include <logdepthbuf_pars_vertex>
    void main() {
    //  #include <begin_vertex>
      // #include <project_vertex>
        #include <logdepthbuf_vertex>
        vUv = uv;
        // 从视图矩阵中提取相机的朝向
    vec3 viewDir = normalize(vec3(
        viewMatrix[0][2], // 视图矩阵的第三列
        viewMatrix[1][2],
        viewMatrix[2][2]
    ));
    
    // 计算俯仰角 (与y轴的夹角)
    // asin返回弧度值 (-π/2 到 π/2)
    vPitch = asin(viewDir.y);
    // pitch = 0 (平视) -> 1.0
    // pitch = ±π/2 (完全俯视/仰视) -> 0.0
    vPitch = cos(vPitch)*0.3;
        // gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        gl_Position = vec4(position, 1.0);
    }`,
  fragmentShader2d: ` 
 #include <logdepthbuf_pars_fragment>
  uniform float iTime;
  uniform float snowSpeed;
  varying float vDistance;
  varying vec2 vUv;
  varying float vPitch;
uniform float rainSpeed;//下雨速度
uniform float rainAngle;//下雨倾斜角度
float PI = 3.1415926;
 //随机数
float random(in vec2 uv) {
    return fract(sin(dot(uv.xy, vec2(12.9898, 78.233))) *
        43758.5453123);
}
 //噪声函数
float noise(in vec2 uv) {
    vec2 i = floor(uv);
    vec2 f = fract(uv);
    f = f * f * (3. - 2. * f);

    float lb = random(i + vec2(0., 0.));
    float rb = random(i + vec2(1., 0.));
    float lt = random(i + vec2(0., 1.));
    float rt = random(i + vec2(1., 1.));

    return mix(mix(lb, rb, f.x), mix(lt, rt, f.x), f.y);
}
//下雨效果
float rain(vec2 uv) {
    float travelTime = (iTime * 0.05*snowSpeed) + 0.1;

    vec2 tiling = vec2(1., .01);
    vec2 offset = vec2(travelTime * 0.5 + uv.x * 0.2, travelTime * 0.2);

    vec2 st = uv * tiling + offset;

    float rain = 0.1;
    float f = fract(noise(st * 200.5) * noise(st * 125.5) * rainSpeed);
    f = clamp(pow(abs(f), 15.0) * 1.5 * (rain * rain * 125.0), 0.0, 0.25);
    return f;
}
//旋转角度
mat2 rotate2d(float angle) {
    return mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
}
  void main(){

   #include <logdepthbuf_fragment>

    mat2 a = rotate2d(rainAngle * PI);
    float rain = rain(vUv * a*vec2(200.,400.));
    if(rain <= 0.0) {
        discard;
        return;
    }
    vec3 col = vec3(1.0);
    gl_FragColor = vec4(col, rain*vPitch);

  }`,
}

export default RainShader